<app-breadcrumb [title]="'year'|translate" [items]="['security'|translate]" [active_item]="'year'|translate"></app-breadcrumb>
<style>
  .custom-card-erp{
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;
  }

  @media screen and (max-width: 800px) {
    .desktop-hidden {
      display: initial;
    }
    .mobile-hidden {
      display: none;
    }
  }
  @media screen and (min-width: 800px) {
    .desktop-hidden {
      display: none;
    }
    .mobile-hidden {
      display: initial;
    }
  }

</style>

<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">


      <div class="custom-card-erp">
        <div style="float:left;">
          <input
                  type="text"
                  style="padding:5px;margin:5px auto;width:30%;"
                  placeholder="Type to filter the name column..."
                  (keyup)="updateFilter($event)"
          />

          <div style="float: right; margin: 5px;">
            <div class="btn-group-vertical me-2" role="group" aria-label="Vertical button group" *ngIf="this.isButtonVisible">
              <div ngbDropdown placement="top" class="btn-group" role="group">
                <button type="button" class="btn btn-outline-primary dropdown-toggle" id="dropdownBasic1"
                        ngbDropdownToggle>{{'global actions'|translate}}</button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                  <button class="dropdown-item" (click)="deleteSelectedYearRows()">{{'delete selection'|translate}}</button>
                </div>
              </div>
            </div>

            <button class="btn btn-outline-primary" (click)="addYear()">{{'add'|translate}}</button>
          </div>

        </div>

        <ngx-datatable
                style="width: 100%"
                class="material striped"
                selectionType="checkbox"
                [rows]="rows"
                [headerHeight]="50"
                [footerHeight]="50"
                [limit]="10"
                rowHeight="auto"
                columnMode="force"
                [scrollbarH]="true"
                [loadingIndicator]="loadingIndicator"
                [reorderable]="reorderable"
                [selected]="selected"
                (activate)="onActivate($event)"
                (select)="onSelect($event)"
                [selectAllRowsOnPage]="false"
        >
          <ngx-datatable-column
                  [width]="55"
                  [sortable]="false"
                  [canAutoResize]="false"
                  [draggable]="false"
                  [resizeable]="false"
                  [headerCheckboxable]="true"
                  [checkboxable]="true"
                  [frozenLeft]="true"
          >

          </ngx-datatable-column>

          <ngx-datatable-column name="year">
            <ng-template let-column="column" ngx-datatable-header-template>
              <span class="f-w-700 sp-policy-erp">{{'year'|translate}}</span>
            </ng-template>

            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
              <ng-container *ngIf="row.isCurrent === true; else otherYear">
                <span class="badge badge-light-success" style="font-size: 13px">{{row.year}}</span>
              </ng-container>
              <ng-template #otherYear>
                <span>{{row.year}}</span>
              </ng-template>
            </ng-template>

          </ngx-datatable-column>

          <ngx-datatable-column name="startAt">
            <ng-template let-column="column" ngx-datatable-header-template>
              <span class="f-w-700 sp-policy-erp">{{'start at'|translate}}</span>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="endAt">
            <ng-template let-column="column" ngx-datatable-header-template>
              <span class="f-w-700 sp-policy-erp">{{'end at'|translate}}</span>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="institution">
            <ng-template let-column="column" ngx-datatable-header-template>
              <span class="f-w-700 sp-policy-erp">{{'institution'|translate}}</span>
            </ng-template>
            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
              {{row.institution ? row.institution.name : "" }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="actions">
            <ng-template let-column="column" ngx-datatable-header-template>
              <span class="f-w-700 sp-policy-erp">{{'actions'|translate}}</span>
            </ng-template>

            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
              <ng-container *ngIf="row.isCurrent == false">
                  <a (click)="editYear(row)"><i class="icon-pencil-alt text-success" style="cursor: pointer"></i></a>
                  <a (click)="deleteYear(row.id)"><i class="icon-trash text-danger ms-2" style="cursor: pointer"></i></a>
                  <a (click)="setCurrentYear(row.id)"><i class="icon-check text-success-emphasis ms-2" style="cursor: pointer"></i></a>
              </ng-container>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>


    </div>
  </div>
</div>




